import styles from './InteractivePlatforms.module.css';
import mobile1 from "../../../assets/images/online/softwarePlatforms/img453.jpg";
import mobile2 from "../../../assets/images/online/softwarePlatforms/img450.jpg";
import design from "../../../assets/images/online/softwarePlatforms/3dProductDesign.jpg";
import js1 from "../../../assets/images/online/softwarePlatforms/JavaScript1 (1).jpg";
import js2 from "../../../assets/images/online/softwarePlatforms/JavaScript1 (2).jpg";
import py1 from "../../../assets/images/online/softwarePlatforms/py1 (1).jpg";
import py2 from "../../../assets/images/online/softwarePlatforms/py1 (2).jpg";
import { FaMobileAlt, FaCube, FaJs, FaPython } from 'react-icons/fa';

const InteractivePlatforms = () => {
  const platforms = [
    {
      title: "MOBILE APP DEVELOPMENT",
      grade: "Grade 3 till 12",
      icon: FaMobileAlt,
      description: [
        "Learn to design the User Interface and understand different programming concepts for interacting with elements on screen.",
        "Learn the use of various internal sensors of mobile phones",
        "Create games and real-life applications during the learning process.",
        "Publish apps online, code & troubleshoot"
      ],
      images: [mobile1, mobile2]
    },
    {
      title: "3D & PRODUCT DESIGN",
      grade: "Grade 3 till 12",
      icon: FaCube,
      description: [
        "Design and program 3D prototypes using CAD software.",
        "Have you ever wanted to see something you design come to life, and become reality. Anything you see around you is designed in a CAD Software & then prototyped with a 3D Printer. Ex: Specs, Pen, Phone, Laptop, Drones etc",
        "Learn basic Physics such as Scaling, Ratios and Dimensions",
        "Gain Prototyping & Designing skills for additive manufacturing of the future"
      ],
      images: [design]
    },
    {
      title: "JAVA SCRIPT",
      grade: "Grade 6 till 12",
      icon: FaJs,
      description: [
        "Brush up on HTML concepts and forms",
        "Programming concepts such as variables, arrays, conditionals, loops, functions etc.",
        "Write and deploy Code to solve practical web design problems.",
        "Create a dynamic digital application on a website using button click, character typed, or mouse movement.",
        "Create simple games and animation using JavaScript"
      ],
      images: [js1, js2]
    },
    {
      title: "PYTHON CODING",
      grade: "Grade 6 till 12",
      icon: FaPython,
      description: [
        "Python is a widely used general-purpose, text-based programming language used to build just about anything. Great for backend web development, data science and analysis, artificial intelligence, and scientific computing.",
        "Learn the basic syntax and functions used for Python",
        "Apply the algorithmic approach to solve challenges"
      ],
      images: [py1, py2]
    }
  ];

  return (
    <section className={styles.interactivePlatforms}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span className={styles.titleText}>ONLINE SESSIONS WITH INTERACTIVE SOFTWARE PLATFORMS</span>
          <span className={styles.titleLine}></span>
        </h2>
        
        <div className={styles.platformsContainer}>
          {platforms.map((platform, index) => (
            <div key={index} className={styles.platformCard}>
              <div className={styles.cardHeader}>
                <platform.icon className={styles.icon} />
                <div className={styles.headerText}>
                  <h3>{platform.title}</h3>
                  <span className={styles.grade}>{platform.grade}</span>
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.description}>
                  <ul>
                    {platform.description.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className={styles.images}>
                  {platform.images.map((image, idx) => (
                    <img key={idx} src={image} alt={`${platform.title} example ${idx + 1}`} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InteractivePlatforms; 